<template>
  <div class="page-wrapper" >
    <div class="container-fluid h-100 scroll-container" style="overflow-x: scroll">
      <div class="row section">
        <div class="col-2">
          <select class="form-control" v-model="dashBoardFilter.userId">
            <option value="0">All Users</option>
            <option v-for="user in users" :value="user.id">{{user.name}} {{user.email}} {{user.phoneNumber}}</option>
          </select>
          <button class="form-control btn btn-primary" v-if="dashBoardFilter.userId > 0" v-on:click="getUserOrderList">회원주문내역</button>
          <input class="form-control section" v-model="dashBoardFilter.buyer" placeholder="수신인으로 검색 (2글자 이상)"/>

        </div>
        <div class="col-2">
          <select class="form-control" v-model="dashBoardFilter.state">
            <option v-for="state in states" :value="state.val">{{state.title}}</option>
          </select>
        </div>
        <div class="col-2">
          <input type="date" v-model="dashBoardFilter.from" class="form-control" :disabled="dashBoardFilter.state > 0 && dashBoardFilter.state < 10"/>
        </div>
        <div class="col-2">
          <input type="date" v-model="dashBoardFilter.to" class="form-control" :disabled="dashBoardFilter.state > 0 && dashBoardFilter.state < 10"/>
        </div>
        <div class="col-2">

          <span class="border-btn" v-on:click="getOrderList"><i class="fas fa-search"></i> 가져오기</span>
        </div>
      </div>

      <div class="row section">
        <div class="col-6 col-md-3 mode-selector" v-bind:class="{'mode-selected': currentMode == 0}" v-on:click="changeMode(0)">
          주문단위 보기
        </div>
        <div class="col-6 col-md-3 mode-selector" v-bind:class="{'mode-selected': currentMode == 1}" v-on:click="changeMode(1)">
          아이템단위 보기
        </div>
        <div class="col-12 col-md-3">
          <span v-if="currentMode == 1" class="border-btn" v-on:click="downloadExcel"><i class="fas fa-file-excel"></i> 엑셀</span>
        </div>
      </div>
      <hr>
      <div class="row section" style="padding-bottom: 200px;">
        <div class="col-12 horizontal-scrollable">
          <table class="table">
            <thead>
              <tr>
<!--                <th v-if="currentMode == 1" v-on:click="selectAll">선택</th>-->
                <th v-if="currentMode == 0">주문번호</th>
                <th v-if="currentMode == 0">주문일</th>
                <th style="min-width: 100px;" v-if="currentMode == 0">상태</th>
                <th v-if="currentMode == 0">회원 정보</th>
                <th v-if="currentMode == 0">주문자/송장</th>
                <th>상품</th>
<!--                <th></th>-->
<!--                <th>선택</th>-->
<!--                <th>품목 상태</th>-->
<!--                <th style="min-width: 150px;">송장</th>-->
                <th>수신인</th>
                <th>주소</th>
              </tr>
            </thead>
            <tr v-if="currentMode == 0" v-for="(order, index) in orders"  :class="'item-row-state-' + order.state">
<!--              <tr v-for="(item, ii) in order.list">-->
                <td>
                  {{order.orderNumber}}

                </td>
                <td>
                  {{convertTimeToString(order.orderedTime)}}
                </td>
                <td>
                  <div >{{order.totalPrice}}원</div>
                  <div >{{paymentString(order.paymentMethod)}}</div>
                  <select style="-webkit-appearance: none;" class="form-control" v-model="order.state" @change="updateOrder(order)">
                    <option v-for="state in states" :value="state.val">{{state.title}}</option>
                  </select>
                  <div class="border-btn-container" style="maring-top:30px;" >
                  <span v-on:click="deleteOrder(order)"><i class="fas fa-trash"> 삭제</i></span>
                  </div>
                </td>
                <td>
                  <span v-html="getUserInfo(order.userId)"></span>

                </td>
                <td>
                  <span >{{order.buyer}}<br>{{order.contact}}<br>{{order.customNumber}}<br>{{order.email}}</span>
                  <input type="text" class="form-control" v-model="order.awb" @change="updateOrder(order)"/>
                </td>
                <td>
                  <ul>
                    <li v-for="item in order.list">{{item.productTitle}} x {{item.amount}}</li>
                  </ul>
<!--                  {{item.title}} x {{item.amount}}<br><strong>[{{item.productId}}]</strong>-->
                </td>
<!--                <td>-->
<!--                  <span v-if="item.placeOrderTimeTo > 0">{{convertTimeToString(item.placeOrderTimeTo)}}까지 선택</span>-->
<!--                </td>-->
<!--                <td>-->
<!--                  <ul v-if="item.list != undefined && item.list.length > 0">-->
<!--                    <li v-for="option in item.list" class="clickable-item" v-on:click="setShowItem(option)"><strong>[{{option.productId}}]</strong> {{option.title}} </li>-->
<!--                  </ul>-->
<!--                </td>-->
<!--                <td>-->
<!--                  <select style="-webkit-appearance: none;" class="form-control" v-model="item.state" @change="updateOrder(item)">-->
<!--                    <option v-for="state in states" v-if="state.selectable==true" :value="state.val">{{state.title}}</option>-->
<!--                  </select>-->
<!--                </td>-->
<!--                <td><input type="text" class="form-control" v-model="item.awb" @change="updateOrder(item)"/></td>-->
                <td>
                  {{order.buyer}}
                </td>
                <td>
                  {{order.postCode}}
                  <br>
                  {{order.address}}
                  <span v-if="order.address2 != null && order.address2.length > 0">{{order.address2}}</span>
                </td>

<!--              </tr>-->
            </tr>
<!--            <tbody v-if="currentMode == 1">-->
<!--             <tr v-for="(item, ii) in orders" :class="'item-row-state-' + item.state">-->
<!--               <td><input type="checkbox" v-bind:value="ii" v-model="selectedItems" @click="updateCheckall($event, ii)"/></td>-->
<!--               <td>-->
<!--                 {{item.orderNumber}}-->
<!--                 <span v-on:click="deleteOrder(item)"><i class="fas fa-trash"> 삭제</i></span>-->
<!--               </td>-->
<!--               <td class="clickable-item"  v-on:click="setShowItem(item)">-->
<!--                 <strong>[{{item.productId}}]</strong> {{item.title}} x {{item.amount}}-->
<!--               </td>-->
<!--               <td>-->
<!--                 <span v-if="item.placeOrderTimeTo > 0">{{convertTimeToString(item.placeOrderTimeTo)}}까지 선택</span>-->
<!--               </td>-->
<!--               <td>-->
<!--                 <ul v-if="item.list != undefined && item.list.length > 0">-->
<!--                   <li v-for="option in item.list" class="clickable-item"  v-on:click="setShowItem(option)"><strong>[{{option.productId}}]</strong> {{option.title}} </li>-->
<!--                 </ul>-->
<!--               </td>-->
<!--               <td>-->
<!--                 <select style="-webkit-appearance: none;" class="form-control" v-model="item.state" @change="updateOrder(item)">-->
<!--                   <option v-for="state in states"  v-if="state.selectable==true" :value="state.val">{{state.title}}</option>-->
<!--                 </select>-->
<!--               </td>-->
<!--               <td><input type="text" class="form-control" v-model="item.awb" @change="updateOrder(item)"/></td>-->
<!--               <td>-->
<!--                 {{item.buyer}}-->
<!--               </td>-->
<!--               <td>-->
<!--                 {{item.postCode}}-->
<!--               </td>-->
<!--               <td>-->
<!--                 {{item.address}} {{item.address2}}-->
<!--               </td>-->
<!--             </tr>-->
<!--            </tbody>-->
          </table>
        </div>
      </div>
    </div>
    <div class="clickable-fullbackground" v-if="itemToShow != false" v-on:click="closeShowItem">
      <div class="fullscreen-content-wrapper">
        <div class="container-fluid h-100">
          <div class="row h-100">
            <div class="col-6 h-100" style="overflow-y: scroll">
              <img v-for="path in itemToShow.images" :src="path"/>
            </div>
            <div class="col-6">
              <h2>[{{itemToShow.productId}}] {{itemToShow.title}}</h2>

            </div>
          </div>
        </div>
      </div>

    </div>
    <v-dialog width="500"/>
    <transition name="dissolve">
      <div class="progressView" v-if="isLoading==true">
        <div class="center-container">
          <div class="content-center">
            <img src="/static/img/beible-logo-black.png" width="300px" class="bounce-anim"/>
            <p class="loading-message"> {{loadingMessage}}</p>
          </div>

        </div>
      </div>
    </transition>
  </div>

</template>

<script>

    var XLSX = require('xlsx');
    import {millisToDate, getStateList} from "../api/utils";
    import {getUserList} from "../api/user";
    import {queryOrders, updateOrder, queryOrdersItems, deleteOrder} from "../api/order";
    import moment from 'moment';
    export default {
        name: "Home",
        data() {
            return {

                orders:[],
                users:[],
                dashBoardFilter:{
                    from:0,
                    to:0,
                    userId:0,
                    state:0,
                    buyer:'',
                },
                states:[

                ],
                currentMode:0,
                isLoading:false,
                loadingMessage:'',
                itemToShow:false,

                isCheckAll: false,
                selectedItems: [],
            }
        },
        components: {

        },
        created() {
            let today = new Date();
            this.$data.dashBoardFilter.from = millisToDate((today.getTime()-(7*24*60*60*1000)), '-');
            this.$data.dashBoardFilter.to = millisToDate(today.getTime(), '-');
            this.$data.states = getStateList();
        },
        mounted(){
            this.getUserList();
            this.getOrderList();
        },
        beforeDestroy() {
        },
        computed: {



        },
        methods: {

            selectAll: function () {
              console.log("select All <<");
              this.$data.isCheckAll = !this.$data.isCheckAll;
              this.$data.selectedItems = [];
              //var unselectableFound = false;
              if (this.$data.isCheckAll) {
                for (var key in this.$data.orders) {
                  console.log("Select all " + key);
                  this.$data.selectedItems.push(key)

                }
              }

              console.log("select All >>");
            },
            updateCheckall: function (e, index) {
              console.log("updateCheckall");
              // if (e.shiftKey) {
              //   console.log("shif key clicked");
              //   let lastIndex = 0;
              //   if(this.$data.selectedItems.length > 0) {
              //     lastIndex = this.$data.selectedItems[this.$data.selectedItems.length-1];
              //   }
              //
              //   if(index > lastIndex) {
              //     for(let i = lastIndex+1 ; i < index ; i++) {
              //       let found = false;
              //       for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
              //         if(this.$data.selectedItems[j] === i) {
              //           this.$data.selectedItems.splice(j, 1);
              //           found = true;
              //           break;
              //         }
              //       }
              //       if(found == false) {
              //         this.$data.selectedItems.push(i);
              //       }
              //     }
              //   } else {
              //     for(let i = index+1 ; i < lastIndex ; i++) {
              //       let found = false;
              //       for(let j = 0 ; j < this.$data.selectedItems.length ; j++) {
              //         if(this.$data.selectedItems[j] === i) {
              //           this.$data.selectedItems.splice(j, 1);
              //           found = true;
              //           break;
              //         }
              //       }
              //       if(found == false) {
              //         this.$data.selectedItems.push(i);
              //       }
              //     }
              //   }
              // }
              if (this.$data.selectedItems.length == this.$data.orders.length) {
                this.$data.isCheckAll = true;
              } else {
                this.$data.isCheckAll = false;
              }
              let self = this;
              console.log("check ");
              console.log(this.$data.selectedItems);
              // for (let i = 0; i < this.$data.selectedItems.length; i++) {
              //     if (this.$data.selectedItems[i] == index && this.$data.items[index].price <= 0) {
              //
              //         console.log(this.$data.selectedItems);
              //         setTimeout(function () {
              //             self.$data.selectedItems.splice(i, 1);
              //             self.$data.items[index].selected = false;
              //         }, 100);
              //         this.$modal.show('dialog', {
              //             title: "ERROR",
              //             clickToClose: false,
              //             text: "무게측정이 되지 않은 송장입니다.",
              //             buttons: [
              //                 {
              //                     title: 'Close',
              //                     handler: () => {
              //                         self.$modal.hide('dialog');
              //
              //                     }
              //                 }
              //             ]
              //         });
              //
              //         return;
              //     }
              // }

              console.log(this.$data.selectedItems);
            },
            showModal: function(title, message) {
                console.log("show modal " + title  + " : " + message);
                this.$modal.show('dialog',{
                    title: title,
                    text: message,
                    buttons:[
                        {title:'Close'}
                    ]
                })
                return;
            },
            paymentString: function(method) {
                if(method === 'transfer') {
                    return '계좌이체';
                } else if(method === 'card') {
                    return '카드결제';
                }
                return method;
            },
            zeroPad: function(num, numZeros) {
                var n = Math.abs(num);
                var zeros = Math.max(0, numZeros - Math.floor(n).toString().length );
                var zeroString = Math.pow(10,zeros).toString().substr(1);
                if( num < 0 ) {
                    zeroString = '-' + zeroString;
                }

                return zeroString+n;
            },
            getUserList: function() {
                let self = this;
                getUserList()
                    .then(function(data) {
                        if(data.success == true) {
                            self.$data.users = data.item;
                        } else {

                        }

                    })
                    .catch(function(err) {

                    })
            },

            getUserInfo:function(id) {
                for(let i = 0 ; i < this.$data.users.length ; i++) {
                    if(this.$data.users[i].id == id) {
                        let text = this.$data.users[i].email + "<br>" + this.$data.users[i].name + "<br>" + this.$data.users[i].phoneNumber;
                        return text;
                    }
                }
                return "비회원";
            },
            convertTimeToString: function(time) {
                return millisToDate(time);
            },
            changeMode: function(mode) {
                if(this.$data.currentMode == mode) {
                    return;
                }
                this.$data.currentMode = mode;
                this.getOrderList();
            },
            getUserOrderList: function() {
                if(this.$data.dashBoardFilter.userId == 0) {
                    return;
                }

                let from = 0;
                let toTime = new Date().getTime();
                let query = 'userId='+this.$data.dashBoardFilter.userId + "&state=0&from=" + from + "&to=" + toTime;

                let self = this;
                self.$data.orders = [];
                self.$data.selectedItems = [];
                self.$data.isLoading = true;
                this.$data.currentMode = 0;
                queryOrders(query)
                    .then(function (data) {
                        self.$data.isLoading = false;
                        if (data.success == true) {
                          self.$data.orders = data.item;
                        } else {
                          self.showModal("", data.message);
                        }
                    })
                    .catch(function (err) {
                        self.$data.isLoading = false;
                        console.log("Error to get order list " + err);
                        if (err.response != undefined) {
                          console.log(err.response);
                        }
                    })

            },
            getOrderList: function() {
                let from = new Date(this.$data.dashBoardFilter.from).getTime();
                let toTime = new Date(this.$data.dashBoardFilter.to);
                toTime.setHours(23);
                toTime.setMinutes(59);
                toTime.setSeconds(59);
                let to = toTime.getTime();

                if(this.$data.dashBoardFilter.state > 0 && this.$data.dashBoardFilter.state < 10) {
                  from = 0;
                  to = new Date().getTime();
                }
                console.log("get order list from " + from + " to " + to + " userId " + this.$data.dashBoardFilter.userId);

                let self = this;
                self.$data.orders = [];
                self.$data.selectedItems = [];
                self.$data.isLoading = true;
                let query = 'userId='+this.$data.dashBoardFilter.userId + "&state=" + this.$data.dashBoardFilter.state + "&from=" + from + "&to=" + to;
                if(this.$data.dashBoardFilter.buyer.length >= 2) {
                    query += "&buyer=" + this.$data.dashBoardFilter.buyer;
                }
                console.log("qeury " + query);
                if(this.$data.currentMode == 0) {
                    queryOrders(query)
                        .then(function (data) {
                            self.$data.isLoading = false;
                            if (data.success == true) {
                                self.$data.orders = data.item;
                            } else {
                                self.showModal("", data.message);
                            }
                        })
                        .catch(function (err) {
                            self.$data.isLoading = false;
                            console.log("Error to get order list " + err);
                            if (err.response != undefined) {
                                console.log(err.response);
                            }
                        })
                } else if(this.$data.currentMode == 1) {
                    queryOrdersItems(query)
                        .then(function (data) {
                            self.$data.isLoading = false;
                            if (data.success == true) {
                                data.item.sort(function (a, b) {
                                  if (a.userId > b.userId) {
                                    return -1;
                                  }
                                  return 1;
                                })
                                self.$data.orders = data.item;
                            } else {
                                self.showModal("", data.message);
                            }
                        })
                        .catch(function (err) {
                            self.$data.isLoading = false;
                            console.log("Error to get order list " + err);
                            if (err.response != undefined) {
                                console.log(err.response);
                            }
                        })
                }
            },
            updateOrder: function(order) {
                let self = this;
                updateOrder(order)
                    .then(function(data) {
                        if(data.success == true) {
                            console.log("updated state");
                        } else {
                            self.showModal("", "Failed to update order item " + data.message);
                        }
                    })
            },
            downloadExcel: function() {
                let url = 'static/utasco-form-customer-template.xlsx';
                let req = new XMLHttpRequest();
                req.open("GET", url, true);
                req.responseType = "arraybuffer";

                this.$data.orders.sort(function (a, b) {
                    if (a.userId > b.userId) {
                        return -1;
                    }
                    return 1;
                })
                // if(this.$data.selectedItems.length > 0) {
                //
                // }
                let self = this;
                req.onload = function (e) {
                    let data = new Uint8Array(req.response);
                    let workbook = XLSX.read(data, {type: "array"});

                    /* DO SOMETHING WITH workbook HERE */
                    let worksheet = workbook.Sheets[workbook.SheetNames[0]];
                    let test = XLSX.utils.sheet_to_json(worksheet);
                    console.log("TEst data");
                    console.log(test);
                    let results = XLSX.utils.sheet_to_json(worksheet, {range: 0, defval: ""});
                    console.log("Read data");
                    console.log(results);
                    let row = results[0];
                    let header = [];
                    for (let key in row) {
                        header.push(key);
                    }
                    let newList = [];
                    let orderCount = 0;
                    for (let i = 0; i < self.$data.orders.length; i++) {
                        if(self.$data.selectedItems.length > 0 && self.$data.selectedItems.includes(i) == false) {
                            continue;
                        }
                        let dataItem = self.$data.orders[i];

                        let count = 0;

                        let address = dataItem.address;
                        if (dataItem.address2.length > 0) {
                            address += " " + dataItem.address2;
                        }
                        console.log(dataItem.buyer + " " + dataItem.title + '  child ' + dataItem.list.length);
                        if(dataItem.list != undefined && dataItem.list.length > 0) {
                            for(let j = 0 ; j < dataItem.list.length ; j++) {
                                let optionItem = dataItem.list[j];
                                orderCount++;
                                let item = [
                                  '',
                                  dataItem.orderNumber,
                                  dataItem.buyer,//buyer
                                  address,
                                  dataItem.postCode,//
                                  dataItem.contact,//contact
                                  '',//message
                                  1,//amount
                                  '',//seller type
                                  '',//custom type
                                  '',//who pay tax
                                  '',//who pay inspection
                                  '',//trade type
                                  dataItem.customNumber,
                                  '',//memo
                                  optionItem.productId,
                                  optionItem.title,
                                  '',//hs code
                                  dataItem.brand,//brand
                                  dataItem.amount,
                                  '',
                                  '',

                                ]
                                newList.push(item);
                            }

                        } else {
                            orderCount++;
                            let item = [
                              '',
                              dataItem.orderNumber,
                              dataItem.buyer,//buyer
                              address,
                              dataItem.postCode,//
                              dataItem.contact,//contact
                              '',//message
                              1,//amount
                              '',//seller type
                              '',//custom type
                              '',//who pay tax
                              '',//who pay inspection
                              '',//trade type
                              dataItem.customNumber,
                              '',//memo
                              dataItem.productId,//memo2
                              dataItem.title,
                              '',//hs code
                              dataItem.brand,//brand
                              dataItem.amount,
                              '',
                              '',

                            ]
                            newList.push(item);
                        }
                    }
                    XLSX.utils.sheet_add_aoa(worksheet, newList, {origin: -1});


                    var sheet = XLSX.utils.json_to_sheet(newList)

                    // A workbook is the name given to an Excel file
                    var wb = XLSX.utils.book_new() // make Workbook of Excel

                    // add Worksheet to Workbook
                    // Workbook contains one or more worksheets
                    XLSX.utils.book_append_sheet(wb, worksheet, 'sheet1') // sheetAName is name of Worksheet

                    // export Excel file
                    var fileName = "Report-" + moment(new Date()).format("YYYYMMDD-hhmmss") + '.xlsx';
                    XLSX.writeFile(wb, fileName); // name of the file is book.xlsx
                }
                req.send();
                console.log("DW form");
            },
            deleteOrder: function(order, parentOrder = null) {
                let self = this;
                this.$modal.show('dialog',{
                    title: order.buyer + ' ' + order.orderNumber + " 카테고리 삭제 ",
                    text:  "삭제하면 해당주문은 지워집니다 (복구 불가능). 삭제하시겠습니까?",
                    buttons:[
                        {
                            title:'아니요',
                            handler:() => {
                                self.$modal.hide('dialog');
                            }
                        },
                        {
                            title:"지우기",
                            handler:() => {
                                self.$modal.hide('dialog');
                                self.deleteOrderItemConfirmed(order, parentOrder);
                            }

                        }
                    ]
                })
            },
            deleteOrderItemConfirmed: function(order, parentOrder = null) {
                let self = this;
                deleteOrder(order)
                    .then(function(data){
                        if(data.success == true) {
                            if(data.item != undefined) {
                                if(parentOrder == null) {
                                    for (let i = 0; i < self.$data.orders.length; i++) {
                                        if (self.$data.orders[i].id == data.item.id) {
                                            self.$data.orders.splice(i, 1);
                                        }
                                    }
                                } else {
                                    for (let i = 0; i < parentOrder.list.length; i++) {
                                        if (parentOrder.list[i].id == data.item.id) {
                                            parentOrder.list.splice(i, 1);
                                        }
                                    }
                                }
                            }
                        } else {
                            self.showModal("", "삭제 실패 했습니다. "+ data.message);
                        }
                    })
                    .catch(function(err){
                        let message = err;
                        if(err.response != undefined) {
                            message += " " + err.response;
                        }
                        self.showModal("ERROR", "에러 발생 했씁니다. " + message);
                    })
            },


            closeShowItem: function() {
                this.$data.itemToShow = false;
            },
            setShowItem: function(item) {
                this.$data.itemToShow = JSON.parse(JSON.stringify(item));
                this.$data.itemToShow.images = [];
                console.log("setShowItem");
                console.log(this.$data.itemToShow)
                if(this.$data.itemToShow.imageUrls != undefined && this.$data.itemToShow.imageUrls.length > 0) {
                    this.$data.itemToShow.images = this.$data.itemToShow.imageUrls.split(',');
                }
            }
        }
    }
</script>

<style lang="css" scoped>
  .section {
    margin-top:20px;
  }
  label.form-control {
    border:none;
  }
  .stock-in {
    border-left:5px solid blue;
  }
  .stock-out {
    border-left:5px solid red;
  }
  .stock-correction {
    border-left:5px solid green;
  }

  .page-wrapper {
    display: flex;
    flex-flow: column;
    height: 100%;
    font-size: small;
  }
  .form-control {
    font-size: small;
  }
  .box {
    width:100%;
    height: 100%;
    position: relative;
    /*display: flex;*/
    /*flex-flow: column;*/
  }
  .top {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 50px;
  }
  .content {
    position: absolute;
    top: 0;
    left: 0;
    width: 100%;
    height: 100%;
    padding-top:50px;

  }
  .top-label {
    padding-left: 20px;
    padding-right: 20px;
  }
  .top-selection {
    width: 200px;
    height: calc(1.5em + .75rem + 2px);
    padding: .375rem .75rem;
    font-size: 1rem;
    font-weight: 400;
    line-height: 1.5;
    color: #495057;
    background-color: #fff;
    background-clip: padding-box;
    border: 1px solid #ced4da;
    border-radius: .25rem;
    transition: border-color .15s ease-in-out,box-shadow .15s ease-in-out;
  }
  .card {
    border-radius: 10px;
  }
  .card-header {
    border-top-left-radius: 10px;
    border-top-right-radius: 10px;
  }
  .in-card {
    background: cornflowerblue;
    color: white;


  }
  .in-card > * {
    color:white;
  }

  .purchase-sum {
    color:white;
  }

  .out-card {
    background: black;
    color: white;
  }
  .sales-sum {

  }

  .warning-item {
    background: crimson;
    color: white;
  }
  td, th {
    text-align: left;
    min-width: 100px;
  }
  .horizontal-scrollable {
    overflow-x: scroll;
  }
  .item-row-state-0 {
    background: #FF6B6B;
    color:white;
  }
  .item-row-state-1 {
    background: #FF8F8F;

  }
  .item-row-state-2 {
    background: #C7FFB8;
  }
  .item-row-state-3 {
    background: #BAE99A;
  }
  .item-row-state-4 {
    background: #4384FA;
  }
  .item-row-state-5 {
    background: #B1CDFF;
  }
  .item-row-state-6 {
    background: #DCDAFF;
  }.item-row-state-10 {
     background: #ADADAD;
   }

  .mode-selector {
    padding:10px;
    border: 1px solid black;
  }
  .mode-selected {
    background: blue;
    color: white;
  }

  .clickable-fullbackground {
    position: absolute;
    top:0;
    left: 0;
    width: 100%;
    height: 100%;
    background-color: rgba(0,0,0,0.5);
  }
  .fullscreen-content-wrapper {
    position: absolute;
    width: 80%;
    height: 80%;
    top:50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: white;
    border-radius: 10px;
    padding:10px;
  }
  .clickable-item {
    cursor: pointer;

  }
  .clickable-item:hover {
    color:blue;
  }
</style>



// WEBPACK FOOTER //
// src/components/Home.vue